import { Route as RootRoute } from "#/routes/__root";

export function useRequestGameContext() {
  return RootRoute.useLoaderData().session;
}
